export default "__VITE_ASSET__BSs1v1HU__"